import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import SearchContext from "contexts/SearchContext";
import FavoritesContext from "contexts/FavoritesContext";
import SearchResults from "pages/SearchResults";
import Recipe from "pages/Recipe";
import Favorites from "pages/Favorites";

import CssBaseline from "@mui/material/CssBaseline";

function App() {
  // Define initial state for Search context (consumed/used via "contextSearchValue" and provided/updated via "setContextSearchValue")
  const [contextSearchValue, setContextSearchValue] = useState("");

  // Define initial state for Favorites context (consumed/used via "contextFavItems" and provided/updated via "setContextFavItems")
  const [contextFavItems, setContextFavItems] = useState([]);

  return (
    <SearchContext.Provider value={[contextSearchValue, setContextSearchValue]}>
      <FavoritesContext.Provider value={[contextFavItems, setContextFavItems]}>
        {/* context updates are only propagated to components below context providers */}
        <div className="App">
          <CssBaseline />

          {/* Note that React Router paths are slightly different than Express server route paths (/food-recipe-react/api/***) */}
          <Routes>
            <Route path="/recipes" element={<SearchResults />} />
            <Route path="/recipes/:id" element={<Recipe />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="*" element={<SearchResults />} />
          </Routes>
        </div>
      </FavoritesContext.Provider>
    </SearchContext.Provider>
  );
}

export default App;